<template>
  <v-layout row wrap class="layoutTraficVisiteurs bigChat">
    <v-flex xs12 :class="{sm3: visiteurChatSelected}" class="traficListVisiteurs fill-height">
      <v-card class="cardTraficVisiteurs">
        <v-toolbar class="toolbar--dense white" flat >
          <v-toolbar-title class="primary--text">
            {{ $tc('targetedVisitors', datasFilterVisiteursArray.length, { count: datasFilterVisiteursArray.length }) + ' ' +
            $t('outOf') + ' ' + numTotalVisiteur }}
          </v-toolbar-title>
        </v-toolbar>
        <div
          class="wz_contentListesVisiteurs" 
          v-bar
        >
          <v-list two-line dense class="listeTraficVisiteurs">
            <template v-for="(visitor, i) in datasFilterVisiteursArray">
              <wz-watcheebox-visiteur  
                :key="i"
                :datasVisiteur="visitor"
                :visSelectId="visiteurChatSelected"
                @openChat="showChat"
                @loading="loadingChat"
                @stopAlertVisiteur="stopAlert"
              ></wz-watcheebox-visiteur>
            </template>
            <!-- Si offline et pas de visiteur ciblé -->
            <v-alert
              outline
              color="secondary"
              icon="info"
              :value="!datasFilterVisiteursArray.length && status == 'offline'"
              transition="scale-transition"
            >
              {{ $t('noTargetingOffline') }}
            </v-alert>
            
            <v-divider></v-divider>
            <v-subheader class="primary--text">
              {{ $tc('visitors', datasVisiteursSocialNetwokArray.length, { count: datasVisiteursSocialNetwokArray.length }) + ' via ' +
              $tc('socialNetworks', 2, { count: '' }) }}
            </v-subheader>
            <div id="wz_visiteurNonFiltre">
              <template v-for="(visitor, i) in datasVisiteursSocialNetwokArray">
                <wz-watcheebox-visiteur
                  :key="i"
                  :datasVisiteur="visitor"
                  :visSelectId="visiteurChatSelected"
                  @openChat="showChat"
                  @loading="loadingChat"
                ></wz-watcheebox-visiteur>
              </template>
            </div>

            <v-divider></v-divider>
            <v-subheader class="primary--text">
              {{ $tc('visitors', datasNoFilterVisiteursArray.length, { count: datasNoFilterVisiteursArray.length }) + ' ' +
              $t('lowPotential') + ' ' +
              $tc('onYours', $store.state._Sites.sites.length, { count: '' }) + ' ' +
              $tc('sites', $store.state._Sites.sites.length, { count: $store.state._Sites.sites.length })}}
            </v-subheader>
            <div id="wz_visiteurNonFiltre">
              <template v-for="(visitor, i) in datasNoFilterVisiteursArray">
                <wz-watcheebox-visiteur
                  :key="i"
                  :datasVisiteur="visitor"
                  :visSelectId="visiteurChatSelected"
                  @openChat="showChat"
                  @loading="loadingChat"
                ></wz-watcheebox-visiteur>
              </template>
            </div>
          </v-list>
        </div>
      </v-card>
    </v-flex>
    <v-flex v-if="visiteurChatSelected" xs12 sm9 class="traficInfosVisiteur fill-height">
      <div v-if="loadingHistoChat" class="wz_loadingChat text-xs-center">
        <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
      </div>
      <wz-view-chat
        v-else
        :datasViewPupitre="dataVisiteurComputed"
        :placesPupitre="1"
        @click.native="focusView({'view': 1, 'visiteurID': visiteurChatSelected})"
        @activeCobrowsing="openCobrowsing(0)"
        @stopCobrowsing="closeCobrowsing(0)"
      ></wz-view-chat>
    </v-flex>

    <!-- dialog invite a aller sur le pupitre -->
    <v-dialog v-model="dialogInvitePupitre" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('newChatTitle') }}</v-card-title>
        <v-card-text>{{ $t('newChatContent') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary--text" flat @click.stop="dialogInvitePupitre=false">{{ $t('notChange')}}</v-btn>
          <v-btn class="primary--text" flat to="/trafic/chatting">{{ $t('multiChat') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import monitor from '../../mixins/monitor'
export default {
  mixins: [monitor],

  data () {
    return {
      dialogInvitePupitre: false,
      iframeStatus: false,
      chatStatus: false,
      loading: false,
      loadingHistoChat: false,
      visiteurData: {},
      pendingInvit: [],
      filterFront: Number(this.$store.state._User.filterFront)
    }
  },

  methods: {
    // ------------------------------------------------------------------------------
    // tableau type de la liste des visiteurs
    // ['status', 'lang', 'visiteurID', 'roomName', 'socketID', 'siteID', 'notification', 'placePupitre']
    // ------------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // chargement avant affichage du chat et des infos
    // ----------------------------------------------------------------------------
    loadingChat (visiteurInfos) {
      // this.visSelected = visiteurInfos.visiteurID // indique quel visiteur est selectionné
      this.loadingHistoChat = true
    },

    // ----------------------------------------------------------------------------
    // stop le loading histo chat apres le chargement ajax
    // ----------------------------------------------------------------------------
    stopLoadingHistoChat () {
      this.loadingHistoChat = false // active le loading de chargement du chat
    },

    // ----------------------------------------------------------------------------
    // affiche le cobrowsing
    // ----------------------------------------------------------------------------
    showIframeMirroring (visiteurInfos) {
      this.iframeStatus = true // iframe visible
      this.visiteurData = visiteurInfos // infos du visiteur selectionné pour le cobrowsing
    },

    // ----------------------------------------------------------------------
    // Ouvre le cobrowsing avec le client
    // et ferme tous les autres cobrowsing ouvert
    // ----------------------------------------------------------------------
    openCobrowsing (num) {
      // console.log('openCobrowsing', num)
      this.iframeStatus = true // iframe visible
    },
    // ----------------------------------------------------------------------
    // Ferme le cobrowsing avec le client
    // ----------------------------------------------------------------------
    closeCobrowsing (num) {
      // console.log('closeCobrowsing', num)
      this.iframeStatus = false // iframe invisible
    },

    // ----------------------------------------------------------------------------
    // cache le cobrowsing
    // ----------------------------------------------------------------------------
    hideIframeMirroring () {
      this.iframeStatus = false // iframe visible
    },

    // ----------------------------------------------------------------------------
    // affiche le chat
    // ----------------------------------------------------------------------------
    showChat (visiteurInfos) {
      // console.log('showChat', visiteurInfos)
      this.chatStatus = true // iframe visible
      this.loadingHistoChat = false
      this.visiteurData = visiteurInfos // infos du visiteur selectionné
      // Connection à la room visiteur
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurInfos.visiteurID})
      // Enregistre dans le store l'id du visiteur
      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', {sessionID: visiteurInfos.visiteurID})
      // this.startCheckInfos() // start le monitor
    },

    // ----------------------------------------------------------------------------
    // cache le chat
    // ----------------------------------------------------------------------------
    // hideChat () {
    //   this.chatStatus = false // iframe visible
    //   // this.visSelected = null // desactive le visiteur selectionné
    //   this.loading = false
    //   // Efface dans le store l'id du visiteur selectionné
    //   this.$store.commit('_StoreWatcheeBox/VISITEUR_REMOVE_CHAT')
    //   // this.visiteurData = '' // infos du visiteur selectionné pour le cobrowsing
    // },

    // ----------------------------------------------------------------------------
    // change le visiteur de liste
    // car il ne recoit plus de message push
    // ----------------------------------------------------------------------------
    stopAlert (visiteurID) {
      // console.log('stopAlert')
      // passer le visiteur de la liste des filtrés
      // à la liste des non filtrés
      var indexVisiteur = _.findIndex(this.datasMonitorVisiteurs, {'visiteurID': visiteurID})
      this.datasFilterVisiteursArray[indexVisiteur].nb_alert = 0
    },

    // ----------------------------------------------------------------------------
    // Création/modification d'un tableau de visiteurs à jour avec nodeJS
    // ----------------------------------------------------------------------------
    modifVisiteursNode () {
      var indexVisiteurSelect = _.findIndex(this.listeAllVisiteurs, {'visiteurID': this.visiteurChatSelected})
      if (indexVisiteurSelect === -1) return
      // change le socketID du visiteur selectionné
      // this.visiteurData.socketID = this.listeAllVisiteurs[indexVisiteurSelect].socketID
       // Affiche/Cache la box visiteur offline
      this.visiteurStatus(this.listeAllVisiteurs[indexVisiteurSelect])
      this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
        'visiteurID': this.visiteurChatSelected
      })
      // indique que la fiche visiteur est ouverte
      // this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', {
      //   'visiteurID': this.visiteurChatSelected
      // })
    },

    // ----------------------------------------------------------------------------
    // Affiche le status visiteur
    // offline/online
    // ----------------------------------------------------------------------------
    visiteurStatus (visiteurInfos) {
      console.log('visiteurStatus', visiteurInfos)
      // Si la div existe
      if (this.$el.getElementsByClassName('presenceVisiteur')[0]) {
        var divCible = this.$el.getElementsByClassName('presenceVisiteur')[0]
        // Si le visiteur est online on cache la div
        if (visiteurInfos.status === 'online') {
          divCible.classList.remove('affiche')
          divCible.classList.add('cache')
        // Sinon le visiteur est offline on affiche la div
        } else {
          divCible.classList.remove('cache')
          divCible.classList.add('affiche')
          // efface le visiteur de la listeAllVisiteurs
          this.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR', visiteurInfos)
        }
      }
    }
  },

  created () {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/chatting' })
    }
  },

  mounted () {
    this.modifVisiteursNode()
    // if (this.visiteurChatSelected) {
    //   // indique que la fiche visiteur est ouverte
    //   this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', {
    //     'visiteurID': this.visiteurChatSelected
    //   })
    // }
  },

  beforeDestroy () {
    this.stopMonitor()
    // window.clearInterval(this.idInterval)
  },

  watch: {
    // ----------------------------------------------------------------------
    // c'est un message ciblé vers un agent
    // regarde si ce message n'est pas du chat en cours
    // si c'est un nouveau chat on ouvre une pupup pour inviter l'agent à aller sur "discussions"
    // ----------------------------------------------------------------------
    'newMessage': function (val, oldval) {
      console.log('newMessage visitor', val)
      if (val.chatSession) {
        if (val.chatSession !== this.visiteurChatSelected) {
          // Si chat en cours
          if (this.chatStatus) {
            // affiche a dialogBox
            this.dialogInvitePupitre = true
          } else {
            this.showChat(val)
          }
        }
      }
    },

    // 'datasVisiteur.newMessage': function (val, oldval) {
    //   console.log('newMessage', val)
    // }

    // ----------------------------------------------------------------------------
    // Quant il y a un changement dans la liste des visiteurs dans le store
    // ----------------------------------------------------------------------------
    'listeAllVisiteurs': function (val, oldval) {
      // regarde dans la liste visiteur et apporte les changement
      this.modifVisiteursNode()
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapState('_User', ['hideTabVisitors']),
    ...mapState('_StoreWatcheeBox', ['listeAllVisiteurs', 'newMessage', 'mySocketID', 'listeChatAgent', 'visiteurChatSelected', 'status']),
    // check si chat selectionné est réouvert
    // checkOpenChatSelected () {
    //   if (!this.visiteurChatSelected) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },

    dataVisiteurComputed () {
      var visteurDataSelected
      // console.log('this.concatAllVisiteurs', this.concatAllVisiteurs)
      if (!this.filterFront) {
        visteurDataSelected = _.find(this.concatAllVisiteurs, {'visiteurID': this.visiteurChatSelected})
      } else {
        visteurDataSelected = _.find(this.listeAllVisiteurs, {'visiteurID': this.visiteurChatSelected})
      }
      // console.log('visiteurChatSelected', this.visiteurChatSelected)
      // console.log('visteurDataSelected', visteurDataSelected)
      return {'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': this.visiteurChatSelected}
    }
  }
}
</script>

<style>
.layoutTraficVisiteurs.smallChat .traficInfosVisiteur {
    -ms-flex-preferred-size: 75% !important;
    flex-basis: 75% !important;
    max-width: 75% !important;
}

.layoutTraficVisiteurs.smallChat .traficChatVisiteur {
    position: absolute;
    top: calc(100% - 58px);
    right: 4px;
    width: 25%;
    -ms-flex-preferred-size: 25% !important;
    flex-basis: 25% !important;
    max-width: 25% !important;
}
.layoutTraficVisiteurs {
  height: calc(100vh - 104px) !important;
}

.cardTraficVisiteurs {
  height:100% !important;
}
.wz_contentListesVisiteurs {
  height: calc(100vh - 176px);
  overflow: auto;
  position: relative;
}
.wz_loadingChat {
  top: calc(50% - 35px);
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/trafic/Visitors.vue